import React from 'react';
import translate from '../../../utils/translate';

export default class extends React.Component {
  static propTypes = {
    fees: React.PropTypes.array.isRequired
  };

  renderFeesList = () => {
    return this.props.fees.map(function (obj, index) {
      return (
        <tr key={index}>
          <td className="feebreakdown__table__cell">
            <div className="feebreakdown__delivery">{obj.feeName}</div>
            <div className="feebreakdown__destination">{obj.destination}</div>
          </td>
          <td className="feebreakdown__table__cell--destination">{obj.destination}</td>
          <td className="feebreakdown__fee">{obj.fee}</td>
        </tr>
      );
    });
  };

  render () {
    const text = {
      delivery: translate('deliveryFeeModule', 'DELIVERY_TYPE'),
      destination: translate('deliveryFeeModule', 'DELIVERY_DESTINATION'),
      deliveryFee: translate('deliveryFeeModule', 'DELIVERY_FEE')
    };

    return (
      <div className="feebreakdown">
        <table className="feebreakdown__table" data-component="feeBreakDownTable">
          <thead>
            <tr>
              <th className="feebreakdown__table__header">
                {text.delivery}
                <span className="feebreakdown__destinationtext"> / {text.destination}</span>
              </th>
              <th className="feebreakdown__table__header--destination">{text.destination}</th>
              <th className="feebreakdown__table__header--right" >{text.deliveryFee}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderFeesList()}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/feebreakdown/index.js